import React, { useContext, useEffect, useState } from 'react';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { CancelRounded } from '@mui/icons-material';
import pageStylePops from './pageStylePops.module.css';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';

const PopUpClearComp = (props) => {

    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);

    const [open, setOpen] = useState(true);
    const [inputTxt, setInputTxt] = useState("");
    const [err, setErr] = useState((props.errorMsg == "") ? false : true);

    useEffect(() => {

    }, [])

    const saveMe = () => {
        props.okClick();
        handleClose();

    };


    const handleClose = () => {
        (props.cancelClick) ?
            props.cancelClick() :
            props.closePop();
    };

    return (
        <Dialog open={open}
            className={`${pageStylePops.popFullComp} ${props.cssStyl ? props.cssStyl : ""} onTopOfAll`}
            classes={{
                paper: props.fullPop ?
                    (!mobiOrNot) ? pageStylePops.dialogPaperFullSize : pageStylePops.dialogPaperFullSizeMobi
                    : pageStylePops.customDialogPaper
                ,
                container: pageStylePops.customDialogContainer
            }}
        >
            {!props.noCloseBtn &&
                <div className={pageStylePops.closePopWinBtn} onClick={() => handleClose()} >
                    <CancelRounded className={`${pageStylePops.cancelBtnX} pointing`} />
                </div>
            }
            <DialogTitle className={props.noLineStart ? "" : pageStylePops.customDialogTitle}>
                {props.title}
            </DialogTitle>
            <DialogContent className={props.inDialogCss}>
                <DialogContentText component="div" className={pageStylePops.customDialogContent}>
                    {props.theInsideComp}
                </DialogContentText>

                {err ? <div style={{ color: 'red', fontWeight: 'bold' }}>{props.errorMsg}</div> : ""}

            </DialogContent>
            {
                props.okClick &&
                <DialogActions >
                    <button type="button"
                        className={`pointing centerMe btn btn-success ${props.btnFStyle || ""}`}
                        onClick={() => { props.okClick(); handleClose(); }}>
                        {(props.BtnTxt != null) ? props.BtnTxt : "המשך"}</button>
                </DialogActions>
            }
            <DialogActions >
                {props.btnClick2 != null ?
                    <>
                        <span>&nbsp;&nbsp;</span>
                        <button type="button"
                            className={`btn-success btnPopRegularSec ${props.btnFStyle || "btnPopRegular"}`}
                            onClick={() => { props.btnClick2(); handleClose(); }}>
                            {(props.BtnTxt2 != null) ? props.BtnTxt2 : "ביטול"}</button>
                    </>
                    : ""}
            </DialogActions>
        </Dialog >

    );
}

export default PopUpClearComp;